import s from '../../styles/components/redeem/RedeemLoader.module.css';

export default function RedeemLoader({ ui }) {
  return (
    <div className={s.wrap}>
      <div className={s.spinner} />
      <p className={s.message}>{ui.message}</p>
    </div>
  );
}